import asteroid1 from "../../assets/random/astroid1.png";
import asteroid2 from "../../assets/random/astroid2.png";
import asteroid3 from "../../assets/random/astroid3.png";

const ASTEROID_IMGS = [asteroid1, asteroid2, asteroid3];

const ASTEROIDS = [
  { x:  4, y:  7, size: 58, rotate:  18, img: 0 },
  { x: 20, y: 13, size: 42, rotate: -12, img: 2 },
  { x: 79, y:  8, size: 50, rotate:  40, img: 1 },
  { x:  6, y: 44, size: 66, rotate:  30, img: 1 },
  { x: 40, y: 35, size: 38, rotate:  25, img: 0 },
  { x: 88, y: 50, size: 52, rotate: -55, img: 2 },
  { x: 14, y: 82, size: 44, rotate:  62, img: 2 },
  { x: 56, y: 87, size: 36, rotate: -20, img: 0 },
  { x: 84, y: 74, size: 60, rotate:  10, img: 0 },
];

// Mulberry32 seeded PRNG — fixed seed means fixed positions on every page load
function makeRng(seed: number) {
  let s = seed;
  return () => {
    s = (s + 0x6D2B79F5) | 0;
    let t = Math.imul(s ^ (s >>> 15), 1 | s);
    t = (t ^ (t + Math.imul(t ^ (t >>> 7), 61 | t))) >>> 0;
    return t / 4294967296;
  };
}
const rng = makeRng(0xdeadbeef);
const STARS = Array.from({ length: 160 }, (_, i) => ({
  id: i,
  x: rng() * 100,
  y: rng() * 100,
  size: rng() < 0.7 ? 1 : rng() < 0.85 ? 1.5 : 2,
  opacity: 0.65 + rng() * 0.35,
}));

// Twinkle durations spread across 5 values so adjacent stars rarely sync
const TWINKLE_DURATIONS = [3.1, 4.3, 2.6, 5.2, 3.8];

export default function Stars() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: 0,
        overflow: "hidden",
        // Faint nebula clouds — depth cue without glow
        background: `
          radial-gradient(ellipse 45% 30% at 12% 22%, rgba(255,37,102,0.022) 0%, transparent 100%),
          radial-gradient(ellipse 55% 40% at 82% 65%, rgba(18,10,50,0.18) 0%, transparent 100%)
        `,
      }}
    >
      {STARS.map((s) => {
        const twinkles = s.id % 8 !== 0; // ~87% of stars twinkle
        const duration = TWINKLE_DURATIONS[s.id % TWINKLE_DURATIONS.length];
        // Negative delay = start mid-animation so stars are naturally out of phase
        const delay = -((s.id * 0.41) % duration);

        return (
          <div
            key={s.id}
            style={{
              position: "absolute",
              left: `${s.x}%`,
              top: `${s.y}%`,
              width: s.size,
              height: s.size,
              borderRadius: "50%",
              background: "#FFFFFF",
              opacity: twinkles ? undefined : s.opacity,
              animation: twinkles
                ? `twinkle ${duration}s ease-in-out ${delay}s infinite both`
                : undefined,
            }}
          />
        );
      })}

      {ASTEROIDS.map((a, i) => (
        <img
          key={i}
          src={ASTEROID_IMGS[a.img]}
          alt=""
          style={{
            position: "absolute",
            left: `${a.x}%`,
            top: `${a.y}%`,
            width: a.size,
            height: a.size,
            // transform handled entirely by animation via --rot custom property
            ["--rot" as string]: `${a.rotate}deg`,
            opacity: 0.45,
            animation: `asteroid-drift ${8 + i * 1.4}s ease-in-out ${-(i * 0.9)}s infinite both`,
          }}
        />
      ))}
    </div>
  );
}
